import Swiper from 'swiper'
import { A11y, Navigation } from 'swiper/modules';
import { LuminousGallery } from 'luminous-lightbox'
import 'swiper/css'
import 'swiper/css/a11y'
import 'swiper/css/navigation'
const swiper = new Swiper('.module--multiple-images.has-carousel .swiper', {
  modules: [A11y, Navigation],
  slidesPerView: 1.15,
  spaceBetween: 30,
  breakpointsBase: 'container',
  breakpoints: {
    950: {
      slidesPerView: 2.15
    },
  },
  a11y: {
    enabled: true
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  on: {
    resize: swiperNavPosition
  },
})

function swiperNavPosition(swiper) {
  if (swiper?.slides?.length) {
    const el = swiper.el
    const img = el.querySelector('img')
    if ( img ) {
      const imgHeight = img.clientHeight
      const navButtons = el.querySelectorAll('.swiper-button')
      navButtons.forEach((button) => {
        button.style.setProperty('top', imgHeight/2 + "px");
      })
    }
  }
}

const demoTrigger = document.querySelector('.lightbox-trigger')
if (demoTrigger != null) {
  // eslint-disable-next-line no-new
  new LuminousGallery(document.querySelectorAll('.lightbox-trigger'))
}